// @core/api/endpoints/document/batch_update_blocks.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BatchUpdateBlocksRequest,
  BatchUpdateBlocksResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Batch update blocks
 * Performs multiple block operations atomically in a single transaction. Used for paste, undo/redo, and drag-and-drop of multiple blocks. All operations succeed or fail together.
 */
export async function BatchUpdateBlocks(
  document_id: string,
  data: BatchUpdateBlocksRequest,
  options?: RequestOptions
): Promise<BatchUpdateBlocksResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id/blocks/batch`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  const requestOptions = options;
  return client.post<BatchUpdateBlocksResponse>(requestPath, data, requestOptions);
}
